export default {
  'login.form.title': '登录 商户宝',
  'login.form.userName.errMsg': '用户名不能为空',
  'login.form.password.errMsg': '密码不能为空',
  'login.form.login.errMsg': '登录出错，轻刷新重试',
  'login.form.login.success': '欢迎使用',
  'login.form.userName.placeholder': '用户名：admin',
  'login.form.password.placeholder': '密码：admin',
  'login.form.rememberPassword': '记住密码',
  'login.form.forgetPassword': '忘记密码',
  'login.form.login': '登录',
  'login.form.register': '注册账号',
  'login.banner.slogan1': '商户宝管理系统',
  'login.banner.subSlogan1': '高效便捷的商户运营与数据管理平台',
  'login.banner.slogan2': '一站式商户服务',
  'login.banner.subSlogan2': '订单管理、数据分析、营销推广全覆盖',
  'login.banner.slogan3': '安全稳定 值得信赖',
  'login.banner.subSlogan3': '为您的商户运营保驾护航',
};
